'use client'

import { getTranslationFromJson } from '@patrianna/shared-utils/prismic'

import type { BuilderContent } from 'app/utils/builder'
import BuilderTextContent from 'components/BuilderTextContent'
import Loader from 'components/Loader'
import { IS_BRAND_PULSZ } from 'config/brands'
import content from 'prismic-translates/common.json'
import FooterPortal from 'src/containers/Layouts/Layout/FooterPortal'
import useBuilderCMSData from 'src/hooks/useBuilderCMSData'
import { useAppSelector } from 'src/store/hooks'
import { isAppInitializedSelector } from 'src/store/modules/appConfig/selectors'
import { isLoggedInSelector, getIsAdminOnlyPromoContentSelector } from 'src/store/modules/user/selectors'

import PromoPreviewItem from './PromoPreviewItem'
import classes from './styles.module.scss'

const t = getTranslationFromJson([content])

const PROMOTION_PREVIEWS_FROM_BUILDER = process.env.CMS_DATA_MODEL_PROMOTIONS_PREVIEWS

export default function PromoPreviewsPage(props: { content?: BuilderContent; builderPage: string }) {
  const appInitialized = useAppSelector(isAppInitializedSelector)
  const isLoggedIn = useAppSelector(isLoggedInSelector)
  const isAdminOnlyPromoCallback = useAppSelector(getIsAdminOnlyPromoContentSelector)
  const { builderData: promoPreviews, builderDataLoaded: promoPreviewsLoaded } = useBuilderCMSData(
    PROMOTION_PREVIEWS_FROM_BUILDER,
  )
  const showTextContent = !isLoggedIn && IS_BRAND_PULSZ
  const showExtraPageData = IS_BRAND_PULSZ && props.content && promoPreviewsLoaded

  if (!appInitialized) {
    return <Loader />
  }

  return (
    <>
      {showTextContent && (
        <div className={classes.promoContent} data-test='promotions-seo-text'>
          <h1>{t('pulsz_promo_content_title')}</h1>
          <p>{t('pulsz_promo_content_text')}</p>
        </div>
      )}
      <div className={classes.container}>
        {promoPreviews.map((el) => {
          const isAdminOnlyPromo = isAdminOnlyPromoCallback(el.data.adminOnly)
          if (isAdminOnlyPromo) {
            return null
          }

          return <PromoPreviewItem key={el.data.imageUrl} preview={el} />
        })}
      </div>
      {showExtraPageData && <BuilderTextContent content={props.content} model={props.builderPage} />}
      {promoPreviewsLoaded && <FooterPortal />}
    </>
  )
}
